import React, { useEffect, useState } from 'react';
import FavoriteDrinkCard from '../components/FavoriteDrinkCard';
import FavoriteFoodCard from '../components/FavoriteFoodCard';
import Header from '../components/Header';

function FavoriteRecipes() {
  const [favoriteRecipes, setFavoriteRecipes] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    if (filter === 'all') {
      setFavoriteRecipes(JSON.parse(localStorage.getItem('favoriteRecipes')) || []);
    } else {
      setFavoriteRecipes(JSON.parse(localStorage.getItem('favoriteRecipes')).filter(
        (recipe) => (recipe.type === filter),
      ) || []);
    }
  }, [filter]);

  useEffect(() => {
    setFavoriteRecipes(JSON.parse(localStorage.getItem('favoriteRecipes')) || []);
  }, []);

  return (
    <div className="done-favorite">
      <Header Title="Favorites" />
      <div className="fav-buttons">
        <button
          data-testid="filter-by-all-btn"
          type="button"
          className="f-buttons"
          onClick={ () => setFilter('all') }
        >
          All
        </button>
        <button
          data-testid="filter-by-food-btn"
          type="button"
          className="f-buttons"
          onClick={ () => setFilter('food') }
        >
          Food
        </button>
        <button
          data-testid="filter-by-drink-btn"
          type="button"
          className="f-buttons"
          onClick={ () => setFilter('drink') }
        >
          Drinks
        </button>
      </div>
      <div className="f-recipes">
        {
          favoriteRecipes.length !== 0 ? (
            favoriteRecipes.map((recipe, index) => (
              recipe.type === 'food' ? (
                <FavoriteFoodCard
                  key={ index }
                  recipe={ recipe }
                  index={ index }
                  favoriteRecipes={ favoriteRecipes }
                  setFavoriteRecipes={ setFavoriteRecipes }
                />
              ) : (
                <FavoriteDrinkCard
                  key={ index }
                  recipe={ recipe }
                  index={ index }
                  favoriteRecipes={ favoriteRecipes }
                  setFavoriteRecipes={ setFavoriteRecipes }
                />
              )
            ))
          ) : <p className="noRecipe">Sem receitas :(</p>
        }
      </div>
    </div>
  );
}

export default FavoriteRecipes;
